import { z } from 'zod'

export const schema = z.object({
  reviews: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      description: z.string(),
      points: z.number().int(),
      cottage: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
      }),
      traveler: z.object({
        id: z.string(),
        name: z.string(),
        media: z.object({
          url: z.string(),
        }),
      }),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
